import { AnyType } from '@src/models/common';
import { FiltersController } from '../FiltersController';
import { TFilterSchemeOptions, TFilterValues } from '../models';

export const getDopTextFromOptionList = (options: AnyType[], id: AnyType, filterField?: string) => {
  if (!filterField) return undefined;
  const fullOptions = options.find((o) => o.id === id);

  if (fullOptions) {
    return `${fullOptions[filterField]}`;
  }

  return undefined;
};

/** Получаем текст для отображения выбранных фильтров типа опции */
export const getOptionDopText = async ({
  controller,
  filterScheme,
  filterValue,
  doNotGroup,
}: {
  filterScheme: TFilterSchemeOptions;
  filterValue?: TFilterValues;
  controller: FiltersController;
  doNotGroup?: boolean;
}) => {
  if (!Array.isArray(filterValue)) return undefined;

  //Если значений больше одного просто показываем кол-во
  if (filterValue.length > 1) {
    if (doNotGroup) {
      const textArr = filterValue.map(async (el) => {
        const singleTagText = await getDopTextForSingleTag(el, filterScheme, controller);
        return singleTagText;
      });
      const results = await Promise.all(textArr);

      return results;
    } else {
      return `${filterValue.length}`;
    }
  } else {
    if (filterValue.length === 1) {
      const r = await getDopTextForSingleTag(filterValue[0], filterScheme, controller);
      return r;
    }
  }
};

export const getDopTextForSingleTag = async (filterValue, filterScheme, controller) => {
  const displayText = filterValue[filterScheme.filterField!];

  if (displayText) {
    return displayText;
  } else {
    //Если опции уже проинициализированы рытаемся достать оттуда
    if (Array.isArray(filterScheme.options)) {
      return getDopTextFromOptionList(filterScheme.options, filterValue.id, filterScheme.filterField);
    }

    //Если нет, то загружаем опции и только потом отдаем
    else {
      const fetchOptions = async () => {
        const options = await controller.loadOption(filterScheme as TFilterSchemeOptions);
        if (!Array.isArray(options)) return undefined;

        return getDopTextFromOptionList(options, filterValue.id, filterScheme.filterField);
      };

      return fetchOptions();
    }
  }
};
